export default __webpack_public_path__ + "static/ovcwinner-6c2ee9799642d6661306661c66f99c2d.png";